export const ProgressivePermissions = {
  ReadPermission: "machines.progressives.read",
  EditPermission: "machines.progressives.write",
  EditReadingPermission: "machines.progressives.editMeterReading",
  SensitiveInfoPermission: "machines.progressives.sensitiveInfo",
  AccountingReportsPermission: "machines.progressives.accountingReports",
};
